<template>
    <fragment>
        <b-table :fields="fields" :items="items" :busy="tableBusy" :current-page="currentPage" hover no-border-collapse
            sort-by="" :sort-desc="true" striped stacked="lg" show-empty>
            <template #empty>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #emptyfiltered>
                <span>Não foram encontrados dados.</span>
            </template>
            <template #table-busy>
                <div class="text-center text-dark">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="loading-text">Carregando...</strong>
                </div>
            </template>
            <template #cell(IsItemPreenchido)="data">
                <font-awesome-icon :icon="data.item.IsItemPreenchido ? 'check' : 'cancel'"
                    :class="data.item.IsItemPreenchido ? 'text-success' : 'text-warning'" />
            </template>
            <template #cell(FlFracassado)="data">
                <span>{{ data.item.FlFracassado }}</span>
            </template>
            <template #cell(NmParticipante)="data">
                <seletor-vencedor-item :item="data.item" :participantes="participantes">
                </seletor-vencedor-item>
            </template>
            <template #custom-foot>
                <b-tr class="font-weight-bold">
                    <b-td colspan="4">Totais</b-td>
                    <b-td class="text-right">{{ licitacaoVlTotalEstimado ? formatMoeda(licitacaoVlTotalEstimado) : '' }}</b-td>
                    <b-td></b-td>
                    <b-td class="text-right">{{ licitacaoVlTotalLicitado ? formatMoeda(licitacaoVlTotalLicitado) : '' }}</b-td>
                    <b-td></b-td>
                </b-tr>
            </template>
        </b-table>
        <table-pagination v-if="totalRows > 10" :total-rows="totalRows" :per-page="10" @pageChange="pageChange" />
    </fragment>
</template>

<script lang="ts">
import TablePagination from '@/components/atos-pessoal/TablePagination.vue'
import ldiService from '@/services/licitacoes/ldiService'
import { fieldsItemVencedorLicitacao, nmCredor } from '@/types/licitacoes/ldi/fields-item-licitacao'
import { LicitacaoVencedorItem } from '@/types/licitacoes/ldi/licitacao-vencedor-item'
import { ParticipanteLicitacao } from '@/types/licitacoes/ldi/participante-licitacao'
import { TableField } from '@/types/table-field'
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { Component, Vue } from 'vue-property-decorator'

const CompProps = Vue.extend({
    name: 'DetalhesVencedoresItemTable',
    components: { TablePagination },
    props: {
        idLicitacao: {
            type: Number,
            required: true
        }
    }
})

@Component
export default class DetalhesVencedoresItemTable extends mixins(UtilsTS, CompProps) {
    fields: TableField[] = [...fieldsItemVencedorLicitacao, nmCredor]
    items: LicitacaoVencedorItem[] = []
    participantes: ParticipanteLicitacao[] = []

    //table-related
    currentPage = 1
    pageSize = 10
    totalRows = 0
    tableBusy = false
    licitacaoVlTotalLicitado: number|null = null
    licitacaoVlTotalEstimado: number|null = null

    async mounted(): Promise<void> {
        await this.buscarParticipantes()
        await this.loadData()
    }
    async pageChange(value: number): Promise<void> {
        this.currentPage = value;
        await this.loadData();
    }
    async loadData(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarItensEdicaoVencedores(this.idLicitacao, this.currentPage, this.pageSize)
            if (response) {
                this.items = response.itensComVencedores.map(l => {
                    const item = Object.assign(new LicitacaoVencedorItem(), l)
                    item.tratarDadosDaAPI()
                    return item
                })
                this.licitacaoVlTotalLicitado = response.licitacaoVlTotalLicitado;
                this.licitacaoVlTotalEstimado = response.licitacaoVlTotalEstimado;
                this.totalRows = response.totalRows
            } else {
                this.$toast.error('Erro ao consultar os vencedores da licitação.');
                this.limpar()
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar vencedores. ' + e)
        } finally {
            this.tableBusy = false
        }
    }

    async buscarParticipantes(): Promise<void> {
        try {
            this.tableBusy = true
            const response = await ldiService.buscarParticipantes(this.idLicitacao)
            if (response) {
                this.participantes = response.participantes.map(p => Object.assign(new ParticipanteLicitacao(), p));
            } else {
                this.$toast.error('Erro ao consultar os participantes da licitação.');
            }
        } catch (e) {
            console.error(e)
            this.$toast.error('Falha ao buscar participantes. ' + e)
        } finally {
            this.tableBusy = false
        }
    }

    limpar(): void {
        this.items = []
        this.totalRows = 0
        this.licitacaoVlTotalLicitado = null
        this.licitacaoVlTotalEstimado = null
    }
}
</script>